export default {
  'zh-CN': {
    about: {
      AboutUs: '关于橙联',
      CompanyInformation: '橙联公司简介',
      CareerOpportunities: '人才招聘',
      ContactUs: '联系我们',
      //about01
      OrangeConnex: '橙联公司简介',
      OClimitedt: '橙联股份是一家服务全球跨境电商的科技公司，致力于通过市场分析、系统研发及资源整合，为客户提供物流、金融、大数据等多方面的服务产品，为全球跨境电商提供高品质、全方位的服务解决方案。',
      OClimitedv: '橙联股份由J-Star和全球电子商务先锋eBay联合成立，拥有非常丰富的物流服务经验和客户市场资源，旨在为卖家客户提供快捷 、稳定 、成本领先 、可视及可持续的物流服务，让买家客户享有更加优质贴心的服务体验。',
      //about03
      ContactInformation: '联系方式',
      EMail: '邮箱：CS@orangeconnex.com',
      Tel: '电话：400 126 0008（中国大陆）/ 852 30183458（香港地区）',
      Online: '在线客服',
      Business: '工作时间：周一至周六 9:00-18:00（节假日除外）',
      cTel: '客服中心电话：400 126 0008（中国大陆）/ 852 30183458（香港地区）',
      cEMail: '客服中心邮箱：CS@orangeconnex.com',
      WeChat: '微信公众号：橙联中国',
      Click: '点击在线客服'
    }
  },
  'en-US':{
    about: {
      AboutUs: 'About Us',
      CompanyInformation: 'Company Information',
      CareerOpportunities: 'Career Opportunities',
      ContactUs: 'Contact Us',
      //about01
      OrangeConnex: 'Orange Connex',
      OClimitedt: 'Orange Connex(China) Limited is a technology company that is dedicated service global e-commerce industry. Through market analysis, system development, and resource integration, we provide services in logistic, finance, and big data aspects of global e-commerce industry.',
      OClimitedv: 'Orange Connex(China) Limited is a joint venture between J-Star, and the a pioneer of global e-commerce platform, eBay. Hence supporting our cause with tremendous amount of resources and years of successful experience within the industry. With our enriched background and strong foundation, our product is aimed to redefine our users’ experiences though Speed, Stability, Transparency, Cost Optimization, and Sustainability.',
      //about03
      ContactInformation: 'Contact information',
      EMail: 'E-Mail：CS@orangeconnex.com',
      cEMail: 'E-Mail：CS@orangeconnex.com',
      Tel: 'Tel：400 126 0008（China mainland)/ 852 30183458(HKSAR)',
      cTel: 'Tel：400 126 0008（China mainland)/ 852 30183458(HKSAR)',
      Online: 'Online Customer Service',
      Business: 'Business hours：Monday-Saturday 9:00-18:00 (National Holidays not included.)',
      WeChat: 'WeChat：橙联中国',
      Click: 'Click to Contact Us'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/About_local.js